import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/support.css";

const API_BASE_URL = "https://growrise.shop";

const Support = () => {
  const navigate = useNavigate();

  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const getToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("naxoraToken") ||
      ""
    );
  };

  const fetchTickets = async () => {
    try {
      setLoading(true);
      setError("");

      const token = getToken();

      if (!token) {
        navigate("/login", { replace: true });
        return;
      }

      const res = await fetch(`${API_BASE_URL}/api/support/my`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Failed to fetch tickets");
        return;
      }

      setTickets(data.tickets || []);
    } catch (err) {
      console.error("Support fetch error:", err);
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subject || !message) {
      setError("All fields required");
      return;
    }

    try {
      setSubmitting(true);
      setError("");

      const token = getToken();

      const res = await fetch(`${API_BASE_URL}/api/support`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ subject, message }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Failed to create ticket");
        return;
      }

      setSubject("");
      setMessage("");
      fetchTickets();
    } catch (err) {
      console.error("Support submit error:", err);
      setError("Server error");
    } finally {
      setSubmitting(false);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString();
  };

  return (
    <div className="support-page">
      <div className="support-header">
        <button
          type="button"
          className="support-back-btn"
          onClick={() => navigate("/dashboard")}
          style={{
            background: "rgba(74, 222, 128, 0.08)",
            border: "1px solid rgba(74, 222, 128, 0.35)",
            color: "#4ade80",
          }}
        >
          Back
        </button>
        <h2>Support</h2>
      </div>

      {error && <div className="support-error">{error}</div>}

      <form className="support-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        <textarea
          placeholder="Describe your issue..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>

        <button type="submit" disabled={submitting}>
          {submitting ? "Submitting..." : "Create Ticket"}
        </button>
      </form>

      <div className="support-section">
        <h3>My Tickets</h3>

        {loading ? (
          <div className="support-loading">Loading...</div>
        ) : tickets.length === 0 ? (
          <div className="support-empty">No tickets found</div>
        ) : (
          <div className="support-list">
            {tickets.map((t) => (
              <div className="support-item" key={t.id}>
                <div>
                  <strong>{t.subject}</strong>
                  <span>{formatDate(t.createdAt)}</span>
                </div>

                <div className="support-status">{t.status}</div>

                {t.adminReply && (
                  <div className="support-reply">
                    <strong>Reply:</strong> {t.adminReply}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Support;